import { connect } from 'react-redux'
import usePlacaPrevistaCarregamentoState from './PlacaPrevistaCarregamentoState'
import {
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  OutlinedBtnPrimary,
  SectionTitle,
} from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import React, { useEffect, useState } from 'react'
import { Fieldset } from 'primereact/fieldset'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(PlacaPrevistaCarregamento)

function PlacaPrevistaCarregamento({ ciclo, selectedTp, dispatch }) {
  const { state, localDispatcher } = usePlacaPrevistaCarregamentoState()
  const [globalFilter, setGlobalFilter] = useState('')
  //Hooks
  useEffect(() => {
    localDispatcher.fetchEntregas(ciclo, selectedTp)
  }, [])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatcher.resetMessages()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatcher.resetMessages()
    }
  }, [state.successMessage])

  useEffect(() => {
    state.btnLoading
      ? dispatch(showLoadingBox('Realizando a alteração das Placas'))
      : dispatch(hideLoadingBox())
  }, [state.btnLoading])

  // Render
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Revisão das Placas dos Veículos Previstas para Carregamento" />
      </div>
      <div className="p-col-8">
        <Fieldset legend="Troca de Placa">
          <div className="p-grid">
            <div className="p-col-4">
              <CustomDropdown
                filter
                label="Placa Original"
                options={state.placasOriginais}
                value={state.placaOriginalSelecionada}
                onChange={item => localDispatcher.onPlacaChange('placaOriginal', item)}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                filter
                label="Nova Placa"
                options={state.placasCadastradas}
                value={state.placaCadastradaSelecionada}
                onChange={item => localDispatcher.onPlacaChange('placaCadastrada', item)}
              />
            </div>
            <div className="p-col-4" style={{ paddingTop: 35 }}>
              <OutlinedBtnPrimary
                label="Salvar"
                onClick={() =>
                  localDispatcher.trocarPlacaHandler(
                    state.entregasFiltradas,
                    state.placaCadastradaSelecionada,
                  )
                }
              />
              <div style={{ display: 'inline-block', marginLeft: 8 }}>
                <OutlinedBtnPrimary label="Limpar Filtro" onClick={localDispatcher.limparFiltro} />
              </div>
            </div>
          </div>
        </Fieldset>
      </div>
      <div className="p-col-12">
        <CustomCheckbox
          checked={state.selecionarTodos}
          onChange={localDispatcher.onSelecionarTodosChange}
        >
          Selecionar Todos
        </CustomCheckbox>
      </div>
      <div className="p-col-12">
        <DataTable
          header={<CustomDataTableHeader onChange={setGlobalFilter} />}
          globalFilter={globalFilter}
          value={state.entregasFiltradas}
          emptyMessage="Não existe Placas associadas as entregas"
          rows={10}
          paginator
          loading={state.loading}
        >
          <Column
            header="#"
            body={item => (
              <CustomCheckbox
                checked={item.selected === true}
                onChange={() => localDispatcher.selectEntrega(item)}
              />
            )}
            style={tableCellCentered(80)}
          />
          <Column field="nomeFantasia" header="Cliente" />
          <Column field="cidade" header="Cidade" />
          <Column field="bairro" header="Bairro" style={tableCellCentered(150)} />
          <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
          <Column field="qte_sku" header="Qte Sku" style={tableCellCentered()} />
          <Column
            field="placa_prevista_carregamento"
            header="Placa"
            style={tableCellCentered()}
            body={item => {
              if (item.placa_cadastrada) return item.placa_prevista_carregamento
              else
                return (
                  <span style={{ color: '#FF0000' }}>
                    {item.placa_prevista_carregamento}
                    <div style={{ fontSize: 8, color: '#000' }}>Placa NÃO cadastrada</div>
                  </span>
                )
            }}
          />
        </DataTable>
      </div>
    </div>
  )
}
